import NavBar from '../Components/NavBar/NavBar'
import Hero from "../Components/LandingPage/Hero/Hero";
import Features from "../Components/LandingPage/Features"
import HowItWorks from "../Components/LandingPage/HowItWorks";
import Footer from "./../Components/LandingPage/Footer";
import ThemeChanger from "./../Components/ThemeChanger"
import BMC from '../Components/LandingPage/BMC';

export default function LandingPage() {
  return (
    <div>
      <NavBar />
      <section id="home">
        <Hero />
      </section>
      <section id="features">
        <Features />
      </section>
      <section id="howItWorks">
        <HowItWorks />
      </section>
      <section id="bmc">
        <BMC />
      </section>
      <section >
        <Footer />
      </section>
    </div>

  )
}
